import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer-text'>
            <p>© Copyright Programming Hero | All rights Reserved</p>
        </div>
    );
};

export default Footer;